import script from "./AlertModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertModal.vue?vue&type=script&setup=true&lang=ts"

import "./AlertModal.vue?vue&type=style&index=0&id=585939ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585939ed"]])

export default __exports__